import type {ActionReducerMapBuilder} from '@reduxjs/toolkit';
import {getPostableSocialMediaAccountsForUser} from '@Components/social-media/social-media-thunk';
import type {SocialMediaWizardState} from '@Components/social-media-wizard/social-media-wizard-reducer';
import {doDropPlanLockedAccountsFromSelection, doUpdateAreAccountsLoading, updateWizardSocialAccounts} from '@Components/social-media-wizard/social-media-wizard-reducer';
import type {SocialAccount} from '@Components/social-media/account.vo';
import uniqWith from 'lodash/uniqWith';
import {getNumParentAccounts} from '@Libraries/social-media-account.library';

export const socialMediaWizardExtraReducers = (builder: ActionReducerMapBuilder<SocialMediaWizardState>): void => {
  builder.addCase(getPostableSocialMediaAccountsForUser.fulfilled, (state, action) => {
    const {payload} = action;
    const updatedAccounts: SocialAccount[] = payload.jsonAccounts.concat(state.accounts);

    const uniqueAccounts = uniqWith(updatedAccounts, (a, b): boolean => {
      return a.id === b.id;
    });
    doUpdateAreAccountsLoading(state, false);
    updateWizardSocialAccounts(state, uniqueAccounts);
    doDropPlanLockedAccountsFromSelection(state);
    state.numParentAccountsConnected = getNumParentAccounts(uniqueAccounts);
  });

  builder.addCase(getPostableSocialMediaAccountsForUser.rejected, (state, _action) => {
    doUpdateAreAccountsLoading(state, false);
  });
};
